
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/b2bcontacts",
      function () {
        return require("private-next-pages/[lang]/b2bcontacts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/b2bcontacts"])
      });
    }
  